import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const ReferenceTypeForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
      <TextField
        label={"VCTS Name"}
        register={register("vcts_name")}
        errors={errors?.name}
      />
    </div>
  );
};

export default ReferenceTypeForm;
